<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import {setFirstUrl} from './components/WechatPlugin';
export default {
  created() {
    console.log('app created:', location.pathname);
    setFirstUrl(window.location.href.split('#')[0]);
  }
}
</script>

<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}
.w100p {
  width: 100%;
}
.text-center {
  text-align: center;
}
</style>